import {
  SET_CORRELATION_ID,
  SET_CURRENT_STORY,
} from "../actions/page-data-actions";
const defaultState = {
  container: "closed",
};

const application = (state = { networkBusy: false, paths: [] }, action) => {
  let context = global || window;
  switch (action.type) {
    case SET_CORRELATION_ID:
      return { ...state, correlationId: action.correlationId };
    case SET_CURRENT_STORY:
      return { ...state, currentStoryContainer: action.container };
    case "BEGIN_FETCHING_PAGE_DATA":
      return { ...state, networkBusy: true };
    case "COMPLETE_FETCHING_PAGE_DATA":
      return { ...state, networkBusy: false };
    default:
      return state;
  }
};

export default application;
